import { getArticlesServerProps } from './utils/get-articles-server-props';
import { GrowthBookPageWrapper, GrowthBookPageWrapperProps } from '../../utils/growth-book';
import ArticleHub from '../../src/client/pages/article-hub';
import type { Article } from '../../src/client/types/__codegen__/sanity/graphql';

export type ArticleHubProps = {
  articles: Article[] | null;
  featuredArticle?: Article | null;
  currentPage: number;
  totalArticles: number;
  insuranceType?: string | null;
};

export const getServerSideProps = getArticlesServerProps();

export default function WrappedPage(props: ArticleHubProps & GrowthBookPageWrapperProps) {
  return GrowthBookPageWrapper(props, ArticleHub);
}
